import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { AfterContentInit, AfterViewChecked, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { map, Observable } from 'rxjs';
import { OnlineStripContent } from 'src/app/models';
import { IconButtonComponent, TextButtonComponent } from 'src/app/shared/components';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { OnlineFilterMenuComponent } from 'src/app/shared/components/filter-menu/online/online-filter-menu.component';
import { OnlineProductCardComponent } from 'src/app/shared/components/product/card';
import { StripContainerComponent } from 'src/app/shared/layout/strips/strip-container.component';
import { SanitizeHtmlPipe } from '../../../../shared/pipes/sanitize-html.pipe';
import { ProductOverviewUtility } from '../product-overview.utility';

@Component({
  selector: 'app-online-product-overview',
  templateUrl: './online-product-overview.component.html',
  styleUrls: ['./online-product-overview.component.scss'],
  animations: [
    trigger('searchItemAnimation', [transition(':enter', [style({ opacity: 0 }), animate('400ms ease-out', style({ opacity: 1 }))])]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BreadcrumbComponent,
    OnlineFilterMenuComponent,
    AsyncPipe,
    TextButtonComponent,
    FormsModule,
    IconButtonComponent,
    InfiniteScrollDirective,
    OnlineProductCardComponent,
    SanitizeHtmlPipe,
    StripContainerComponent,
  ],
})
export class OnlineProductOverviewComponent
  extends ProductOverviewUtility
  implements OnInit, AfterViewChecked, AfterContentInit, OnDestroy
{
  strips: Observable<OnlineStripContent[]>;

  override ngOnInit() {
    super.ngOnInit();

    this.strips = this.category$.pipe(
      map((category) => {
        return this.contentService.getOnlineCategoryContent(category?.id);
      }),
    );
  }
}
